import React, {useState, Fragment, useEffect, useRef} from "react";
import axios from "axios";
import {Col, Container, Form, Row} from "react-bootstrap";
import {accountService} from "./Account.service";
import {useParams} from "react-router-dom";
import Moment from "moment/moment";

accountService.isLoggedRedirect();
function App() {

    const [datacv, setDataCv] = useState([]);
    const { id } = useParams();
    const inputRef = useRef(null);
    const [cv, setCv] = useState({});
    const mytoken = JSON.parse(localStorage.getItem('token')).token;
    const config = {headers: { Authorization: `Bearer ${mytoken}` ,  } };

    useEffect((config) => {
        axios.get(process.env.REACT_APP_API_URLSF+`/api/curriculum/`+id, config)
            .then(data => {
                setCv(
                    {
                        title: data.data.title,
                        lastname: data.data.lastname,
                        firstname: data.data.firstname,
                        nationality: data.data.nationality,
                        description: data.data.description,
                        dateofbirth: data.data.dateofbirth,
                        email: data.data.email
                    }
                )
            }).catch(err => console.error(err));
    }, [id]);

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        if(name === 'dateofbirth'){
            setCv({...cv, [name]: value+'T15:52:01+00:00'});
        }else{
            setCv({...cv, [name]: value});
        }
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        if(cv.title || cv.lastname || cv.firstname || cv.nationality || cv.description || cv.dateofbirth || cv.email)
        {
            const newCv = { ...cv}
            setDataCv([...datacv, newCv]);
            setCv({title: "", lastname: "", firstname: "", nationality: "", description: "", dateofbirth: "", email: ""});
            const dataEncodedtoJson = JSON.stringify(newCv);
             axios.put(process.env.REACT_APP_API_URLSF+`/api/curriculum/`+id, dataEncodedtoJson, config)
             .then(data => data.status === 204 ? window.location.replace("/admin/curriculum/"+id) : console.log(data.status))
             .catch(err => console.error(err));
        }
    };


    return (
        <Fragment>
            <section id="signup" className="signup-section">
                <Container key="CurriculumAdmin">
                    <Row>
                        <Col></Col>
                        <Col>
                            <div className="align-self-center" key="CurriculumAdminAlign">
                                <Form onSubmit={handleSubmit}>
                                    <Form.Group className="mb-5" controlId="formBasicEmail">
                                        <Form.Control type="text" name="title" value={cv.title} ref={inputRef} onChange={handleChange}/>
                                        <Form.Label className="mb-3">Curriculum</Form.Label>
                                        <Form.Control size="sm" type="text" name="lastname" value={cv.lastname} ref={inputRef} onChange={handleChange}/>
                                        <Form.Label className="mb-3">Last name</Form.Label>
                                        <Form.Control size="sm" type="text" name="firstname" value={cv.firstname} ref={inputRef} onChange={handleChange}/>
                                        <Form.Label className="mb-3">First name</Form.Label>
                                        <Form.Label></Form.Label>
                                        <Form.Control size="sm" type="date" value={cv.dateofbirth} ref={inputRef} name="dateofbirth" onChange={handleChange} />
                                        <Form.Label className="mb-3">Birth date : {Moment(cv.dateofbirth).format("DD/MM/YYYY")}</Form.Label>
                                        <Form.Control size="sm" type="text" name="nationality" value={cv.nationality} ref={inputRef} onChange={handleChange} />
                                        <Form.Label className="mb-3">Nationality</Form.Label>
                                        <Form.Control size="sm" as="textarea" name="description" value={cv.description} ref={inputRef} onChange={handleChange} />
                                        <Form.Label className="mb-3">Description</Form.Label>
                                        <Form.Control className="form-control" size="sm" type="mail" name="email" value={cv.email} ref={inputRef} onChange={handleChange} />
                                        <Form.Label className="mb-3">Email</Form.Label>
                                        <br/>
                                        <input type="submit" value="Submit" className="btn btn-danger btn-sm justify-content-center"/>
                                    </Form.Group>
                                </Form>
                        </div>
                        </Col>
                        <Col className="items">
                            {datacv.map((item) => {
                                const { id, title, lastname, firstname,nationality, description, email, dateofbirth } = item;
                                return (
                                    <div className="item" key={id}>
                                        <h4>{title} {id}</h4>
                                        <p>{lastname}</p>
                                        <p>{firstname}</p>
                                        <p>{email}</p>
                                        <p>{dateofbirth}</p>
                                        <p>{nationality}</p>
                                        <p>{description}</p>
                                    </div>
                                );
                            })}
                        </Col>
                    </Row>

                </Container>

        </section>
        </Fragment>
    );
}

export default App;
